import { ButtonType, useModal } from '@ampol/design-system';
import { ButtonColor, ButtonVariant } from '@ampol/design-system/lib';
import AddCardModalForm from './AddCardModalForm';
import { useDispatch, useSelector } from 'react-redux';
import { updateCardModalFormValues } from 'actions/cardActions';
import { resetPlasticType } from 'actions/maintenanceActions';
import { useDispatchCardModalMeta } from 'dispatchers/dispatchers';
import CardModal from '../CardModal';
import CardModalIcon from '../CardModalIcon';

export const CARD_MODAL_FORM_ID = 'card-modal-form';

function AddCardModalContent({ onClose }: { onClose: () => void }) {
  return (
    <AddCardModalForm onClose={onClose} formId={CARD_MODAL_FORM_ID}>
      <CardModal.Details />
      <CardModal.DeliveryAddress />
      <CardModal.UsageOptions limitMode='add' />
      <CardModal.ProductsAndServices />
    </AddCardModalForm>
  );
}

export default function useAddCardModal() {
  const dispatch = useDispatch();
  const dispatchCardModalMeta = useDispatchCardModalMeta();
  const accountDefaultsLoading = useSelector((state: any) => state.accountDefaults.isLoading) as boolean;

  const addCardModal = useModal({
    id: 'add-card-modal',
    formId: CARD_MODAL_FORM_ID,
    color: ButtonColor.Blue,
    title: 'Add new card',
    variant: 'triple',
    onClose: () => {
      dispatch(resetPlasticType());
      dispatch(updateCardModalFormValues({}));
      dispatchCardModalMeta({});
    },
    content: (
      <AddCardModalContent
        onClose={() => {
          addCardModal.close();
        }}
      />
    ),
    actions: [
      {
        label: 'Submit',
        type: ButtonType.Submit,
        inactive: accountDefaultsLoading,
        variant: ButtonVariant.Primary,
      },
      {
        label: 'Cancel',
        variant: ButtonVariant.Secondary,
        onClick: () => {
          window.dataLayer.push({
            event: 'Card_Portal_Add_New_Card_Cancel',
            button_click: true,
          });
          addCardModal.close();
        },
      },
    ],
    icon: <CardModalIcon />,
  });

  return addCardModal;
}
